<!--  -->
<template>
  <div class="clientview">
    <div class="tabselecr_box">
      <div class="selcet_box search_box">
        <el-input
          v-model="query.address"
          placeholder="请输入ip"
          style="margin-right:10px;"
          @keyup.enter.native="searchclick"
        />
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div class="mobile-p">
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
        <el-button type="warning" icon="el-icon-plus" @click="importExc">导入</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="importExcr">导入绑定</el-button>
        <input
          ref="fileInput"
          type="file"
          multiple
          style="display: none"
          @change="handleFileChange"
        >
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column prop="account" label="账户" width="200" align="center" />
      <el-table-column prop="port" label="端口" width="200" align="center" />
      <el-table-column prop="pwd" label="密码" width="250" align="center" />
      <el-table-column prop="address" label="IP地址" min-width="300" align="center" />
      <el-table-column prop="bind_count" label="绑定个数" width="200" align="center" />
      <el-table-column prop="client_host" label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="add(2,scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deteleter(scope.row.id)">删除</el-button>
          <el-button type="primary" size="mini" @click="checkList(scope.row.id)">查看绑定</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="type === 1? '新增代理': '编辑代理'"
      :visible.sync="clientdiavieser"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <clientdialog ref="clientdialogview" @updata="updata" />
    </el-dialog>

    <el-dialog
      title="查看绑定"
      :visible.sync="bind_visible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <div style="margin-bottom:12px; display:flex; gap:10px; align-items:center;">
        <el-select
          v-model="bindQuery.type"
          placeholder="选择类型"
          clearable
          filterable
          style="width:220px"
          @change="onBindTypeChange"
          @clear="onBindTypeChange"
        >
          <el-option label="云手机" :value="1" />
          <el-option label="由创" :value="2" />
        </el-select>
        <el-button type="primary" @click="fetchBindList">刷新</el-button>
      </div>

      <el-table
        v-loading="bindLoading"
        :data="bindTableData"
        border
        style="width: 100%"
      >
        <!-- 随便渲染一些字段：按后端返回替换 -->
        <el-table-column prop="instance_type" label="类型" align="center" />
        <el-table-column prop="instance_name" align="center" label="实例名称" />
        <el-table-column prop="created_at_text" label="创建时间" align="center" />
      </el-table>

      <div style="margin-top: 12px;">
        <el-pagination
          background
          layout="prev, pager, next, sizes, total"
          :total="bindTotal"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="bindQuery.page_size"
          :current-page="bindQuery.page"
          @current-change="onBindPageChange"
          @size-change="onBindSizeChange"
        />
      </div>
    </el-dialog>

    <el-dialog
      :title="'导入绑定'"
      :visible.sync="clientdiaviedaili"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <chuandialog ref="chuandialogview" @chuandialogupdata="chuandialogupdata" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { proxyConfigList, proxyConfigDel, proxyConfigImport, proxyRecordList } from '@/api/officialaccount.js'
import clientdialog from './components/clientdialog.vue'
import chuandialog from './components/chuandialog.vue'
export default {
  components: { PaginationRight, clientdialog, chuandialog },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        address: ''
      },
      tableData: [],
      total: 0,
      loading: false,

      clientdiavieser: false,
      type: 1,

      // 查看绑定弹窗
      bind_visible: false,
      bindLoading: false,
      bindTableData: [],
      bindTotal: 0,
      bindQuery: {
        proxy_config_id: '',
        page: 1,
        page_size: 10,
        type: '' // 默认为空，可清空
      },
      clientdiaviedaili: false
    }
  },
  created() {
    this.list()
  },
  methods: {
    async list() {
      this.loading = true
      try {
        const data = await proxyConfigList(this.query)
        this.tableData = data?.data?.list || []
        this.total = data?.data?.total || 0
      } catch (e) {
        this.$message.error('列表获取失败')
      } finally {
        this.loading = false
      }
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    // 搜索 & 回车
    searchclick() {
      this.query.page = 1
      this.list()
    },
    // 重置
    rechargeclick() {
      this.query.page = 1
      this.query.address = ''
      this.list()
    },
    // 新增/编辑
    add(type, item) {
      this.clientdiavieser = true
      this.type = type
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.clientdialogview.send(type)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.clientdialogview.send(type, item)
        })
      }
    },
    updata() {
      this.clientdiavieser = false
      this.list()
    },
    // 删除
    deteleter(id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          await proxyConfigDel({ id })
          this.$message.success('删除成功!')
          // 删除后如果当前页无数据，可回退一页再查，这里做个简单处理
          if (this.tableData.length === 1 && this.query.page > 1) {
            this.query.page -= 1
          }
          this.list()
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 导入
    importExc() {
      this.$refs.fileInput.click()
    },
    async handleFileChange(e) {
      const file = e.target.files[0]
      if (!file || !/\.(xlsx|xls)$/i.test(file.name)) {
        this.$message.warning('只能上传 Excel 文件（.xlsx/.xls）')
        this.$refs.fileInput.value = ''
        return
      }
      const formData = new FormData()
      formData.append('proxy_file', file)
      console.log(file, 'file文件')
      try {
        await proxyConfigImport(formData)
        this.$notify({
          title: '批量创建',
          message: '创建成功',
          type: 'success',
          offset: 190
        })
        await this.list() // 成功后自动刷新
      } catch (err) {
        this.$message.error('批量创建失败')
      } finally {
        this.$refs.fileInput.value = ''
      }
    },

    // 查看绑定
    checkList(id) {
      this.bind_visible = true
      this.bindQuery.proxy_config_id = id
      this.bindQuery.page = 1
      this.bindQuery.page_size = 10
      // type 默认保留当前选择（如果你希望每次打开都清）
      this.bindQuery.type = ''
      this.fetchBindList()
    },
    async fetchBindList() {
      this.bindLoading = true
      try {
        // GET 方式，参数直接传 bindQuery
        const res = await proxyRecordList({ ...this.bindQuery })
        // 根据后端返回结构适配
        this.bindTableData = res?.data?.list || []
        this.bindTotal = res?.data?.total || 0
      } catch (e) {
        this.$message.error('绑定列表获取失败')
      } finally {
        this.bindLoading = false
      }
    },
    onBindTypeChange() {
      this.bindQuery.page = 1
      this.fetchBindList()
    },
    onBindPageChange(p) {
      this.bindQuery.page = p
      this.fetchBindList()
    },
    onBindSizeChange(ps) {
      this.bindQuery.page_size = ps
      this.bindQuery.page = 1
      this.fetchBindList()
    },
    importExcr() {
      console.log('111')
      this.clientdiaviedaili = true
    },
    chuandialogupdata() {
      this.clientdiaviedaili = false
      this.list()
    }
  }
}
</script>

<style scoped lang="less">
.clientview{
  padding: 30px;
}
.tabselecr_box{
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.selcet_box{
  display: flex;
  align-items:flex-end;
}
.btn-box{
  display:flex;
  flex-direction:column;
  gap:1vw;
  button{
    margin:0px;
  }
}
@media (max-width: 768px){
  .mobile-p{
    margin-top:2vw;
  }
}

</style>
